export default __webpack_public_path__ + "8b483f592507cba2f8ef855c692a43aa.svg";